import { AccentScheme, BaseScheme, Theme } from "@/store/user-config-store";
import { Monitor, Moon, Sun } from "lucide-react";

export const THEME_MODE_OPTIONS = [
  { theme: Theme.System, labelKey: "user-settings:SystemMode", Icon: Monitor },
  { theme: Theme.Light, labelKey: "user-settings:LightMode", Icon: Sun },
  { theme: Theme.Dark, labelKey: "user-settings:DarkMode", Icon: Moon },
] as const;

export interface BaseSchemeDefinition {
  scheme: BaseScheme;
  labelKey: string;
  backgroundColor: string;
}

export const LIGHT_BASE_SCHEMES: BaseSchemeDefinition[] = [
  {
    scheme: BaseScheme.Default,
    labelKey: "BaseSchemeDefault",
    backgroundColor: "hsl(240 20% 99%)",
  },
  {
    scheme: BaseScheme.TrueWhite,
    labelKey: "BaseSchemeTrueWhite",
    backgroundColor: "hsl(0 0% 100%)",
  },
];

export const DARK_BASE_SCHEMES: BaseSchemeDefinition[] = [
  {
    scheme: BaseScheme.Default,
    labelKey: "BaseSchemeDefault",
    backgroundColor: "hsl(222 11% 18%)",
  },
  {
    scheme: BaseScheme.TrueDark,
    labelKey: "BaseSchemeTrueDark",
    backgroundColor: "hsl(0 0% 0%)",
  },
  {
    scheme: BaseScheme.TrueDarkDimmed,
    labelKey: "BaseSchemeTrueDarkDimmed",
    backgroundColor: "hsl(0 6% 7%)",
  },
];

export interface AccentSchemeDefinition {
  scheme: AccentScheme;
  labelKey: string;
  primaryColor: string;
  primaryColorDark?: string;
}

export const ACCENT_SCHEMES: AccentSchemeDefinition[] = [
  {
    scheme: AccentScheme.Classic,
    labelKey: "AccentSchemeClassic",
    primaryColor: "hsl(145 80% 29%)",
    primaryColorDark: "hsl(144.8 93.5% 69.6%)",
  },
  {
    scheme: AccentScheme.Ocean,
    labelKey: "AccentSchemeOcean",
    primaryColor: "hsl(210 100% 45%)",
    primaryColorDark: "hsl(210 100% 56%)",
  },
  {
    scheme: AccentScheme.Amber,
    labelKey: "AccentSchemeAmber",
    primaryColor: "hsl(20 85% 42%)",
    primaryColorDark: "hsl(20 85% 55%)",
  },
  {
    scheme: AccentScheme.Rose,
    labelKey: "AccentSchemeRose",
    primaryColor: "hsl(346 84% 49%)",
    primaryColorDark: "hsl(346 84% 61%)",
  },
  {
    scheme: AccentScheme.Violet,
    labelKey: "AccentSchemeViolet",
    primaryColor: "hsl(291 64% 52%)",
    primaryColorDark: "hsl(291 64% 55%)",
  },
];
